<template>
  <div>
    <OpenOrdersModal
      :readOnly="true"
      :id="null"
      :valDeadlineWorkshopOverride="null"
    />
    <b-container variant="primary" fluid class="p-5">
      <b-row>
        <b-col :cols="12">
          <h2>Albaranes</h2>
          <p>En este apartado se pueden gestionar los albaranes.</p>
          <b-row class="mb-3">
            <b-col :cols="12"> </b-col>
          </b-row>

          <b-row>
            <b-col :cols="12">
              <h3>Listado de albaranes</h3>
              <v-server-table
                :url="table.url"
                ref="table"
                class="mt-4"
                :columns="table.columns"
                :options="table.options"
              >
                <div slot="afterFilterWrapper" class="form-group form-inline">
                  <b-button
                    class="ml-3"
                    variant="primary"
                    :to="{
                      name: 'AdminDeliveriesEditScreen',
                      params: { id: 'new' },
                    }"
                    >Nuevo albarán</b-button
                  >
                  <!-- <b-button
                    class="ml-3"
                    variant="primary"
                    v-b-modal.workshop-date-modal
                    ><b-icon icon="calendar-3" /> Calendario de
                    pedidos</b-button
                  > -->

                  <b-button
                    @click="refreshTable()"
                    class="ml-3"
                    variant="outline-primary"
                    ><b-icon icon="arrow-clockwise" /> Refrescar</b-button
                  >
                  <!-- <b-button
                    variant="outline-danger"
                    class="ml-2"
                    :disabled="table.selected.length === 0"
                    @click="removeSelected()"
                    >Eliminar seleccionados</b-button
                  > -->
                </div>

                <div slot="h__checkbox">
                  <b-form-checkbox
                    v-model="table.allSelected"
                    @change="toggleAll"
                  />
                </div>

                <div slot="checkbox" slot-scope="props">
                  <b-form-checkbox
                    :checked="table.selected.includes(props.row.reference)"
                    @change="toggleCell($event, props.row.reference)"
                  />
                </div>

                <template v-slot:modified_at="props">
                  <span>{{ props.row.modified_at }}</span>
                </template>

                <template v-slot:origin="props">
                  <span>{{
                    props.row.order_id
                      ? 'Venta #' + props.row.order_id
                      : 'Stock'
                  }}</span>
                </template>

                <template v-slot:abbr_product_names="props">
                  <div
                    :key="i"
                    v-for="(abbr_product_name, i) in props.row
                      .abbr_product_names"
                  >
                    {{
                      abbr_product_name['qty'] +
                      ' x ' +
                      abbr_product_name['name']
                    }}
                  </div>
                </template>

                <template v-slot:created_at="props">
                  <span>{{ props.row.created_at }}</span>
                </template>

                <template v-slot:total_price="props">
                  <span>{{ props.row.total_price }} €</span>
                </template>

                <template v-slot:status="props">
                  <span>{{ props.row.status | formatStatus }}</span>
                </template>

                <template v-slot:quote_id="props">
                  <div
                    v-if="
                      props.row.deliveriestatushistory_set.length === 1 &&
                      props.row.deliveriestatushistory_set[0].status ===
                        'Delivered'
                    "
                  >
                    Venta en tienda (<b-link
                      :to="{
                        name: 'AdminQuotesEditScreen',
                        params: { id: props.row.quote_id },
                      }"
                      >ppto. {{ props.row.quote_id }}</b-link
                    >)
                  </div>
                  <div v-else-if="props.row.quote_id">
                    <b-link
                      :to="{
                        name: 'AdminQuotesEditScreen',
                        params: { id: props.row.quote_id },
                      }"
                      >ppto. {{ props.row.quote_id }}</b-link
                    >
                  </div>
                  <div v-else>Venta web</div>
                </template>

                <template v-slot:actions="props">
                  <b-button
                    :to="{
                      name: 'AdminDeliveriesEditScreen',
                      params: { id: props.row.id.toString() },
                    }"
                    size="sm"
                    variant="outline-primary"
                    class="mr-2"
                    ><b-icon icon="pencil" aria-hidden="true" />
                  </b-button>

                  <!-- <b-button
                    @click="downloadOrder(props.row.id)"
                    size="sm"
                    variant="outline-primary"
                    class="mr-2"
                    ><b-icon
                      icon="file-earmark-arrow-down"
                      aria-hidden="true"
                    ></b-icon>
                    Pedido
                  </b-button> -->

                  <span
                    :id="'btn-' + props.row.id"
                    class="d-inline-block"
                    tabindex="0"
                  >
                    <!-- <b-button
                      @click="
                        downloadOrderLegal(props.row.id, props.row.invoice)
                      "
                      :id="'btn-' + props.row.id"
                      size="sm"
                      variant="outline-primary"
                      class="mr-2"
                      :disabled="
                        !props.row.billing_address_id ||
                        !props.row.billing_address_company.company_id ||
                        props.row.billing_address_company.company_id === null ||
                        props.row.billing_address_company.company_id === ''
                      "
                      ><b-icon
                        icon="file-earmark-check"
                        aria-hidden="true"
                      ></b-icon>
                      
                      Factura
                    </b-button> -->
                  </span>

                  <b-tooltip
                    v-if="
                      !props.row.billing_address_id ||
                      props.row.billing_address_company.company_id === null ||
                      props.row.billing_address_company.company_id === ''
                    "
                    :target="'btn-' + props.row.id"
                    triggers="hover"
                  >
                    {{
                      !props.row.billing_address_id ||
                      props.row.billing_address_company.company_id === null ||
                      props.row.billing_address_company.company_id === ''
                        ? 'Debe constar una dirección de facturación y esta debe contener un identificador de empresa/autónomo (CIF)'
                        : ''
                    }}
                  </b-tooltip>
                  <b-button
                    @click="downloadDelivery(props.row.id)"
                    size="sm"
                    variant="outline-primary"
                    class="mr-2"
                    ><b-icon
                      icon="file-earmark-arrow-down"
                      aria-hidden="true"
                    ></b-icon>
                    Albarán</b-button
                  >

                  <b-button
                    @click="removeDelivery(props.row.id)"
                    :disabled="props.row.status !== 'Draft'"
                    size="sm"
                    variant="outline-danger"
                    class="mr-2"
                    ><b-icon icon="trash" aria-hidden="true" />
                  </b-button>
                </template>
              </v-server-table>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { uris, actions } from '@/admin/api.js';
import OpenOrdersModal from '@/admin/components/orders/OpenOrdersModal.vue';

import store from '@/admin/store.js';

import moment from 'moment';
import 'moment/locale/es';

export default {
  name: 'AdminDeliveriesScreen',
  props: {},
  components: { OpenOrdersModal },
  data() {
    return {
      table: {
        url: uris.deliveriesURI,
        selected: [],
        allSelected: false,
        columns: [
          'checkbox',
          'id',
          'employee_full_name',
          'status',
          'origin',
          'actions',
        ],
        options: {
          rowClassCallback: function (row) {
            return row.status === 'Received' ? 'bg-light-warning' : '';
          },
          sortable: ['modified_at', 'created_at'],
          headings: {
            origin: 'Origen',
            status: 'Estado',

            abbr_product_names: 'Productos',
            modified_at: 'Modificado',
            id: '# Albarán',
            employee_full_name: 'Creado por',
            actions: 'Acciones',
          },
        },
      },
      sharedState: store.state,
    };
  },
  created() {},
  filters: {
    formatStatus: function (value) {
      return {
        Draft: 'Borrador',
        Received: 'Recibido',
        Workshop: 'En taller',
        Finished: 'Terminado',
        Sent: 'Enviado',
        Delivered: 'Entregado',
      }[value];
    },
    formatDateTime: function (value) {
      return moment(value).format('DD/MM/YYYY HH:mm');
    },
    formatCurrency(val) {
      return val.toFixed(2);
    },
  },
  methods: {
    refreshTable() {
      this.$refs.table.refresh();
    },
    downloadOrder(id) {
      actions.downloadOrder(id).then((x) => {
        let fileName = 'Pedido.pdf';

        const contentDisposition = x.headers['content-disposition'];
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename=(.+)/);
          if (fileNameMatch.length === 2) {
            fileName = fileNameMatch[1];
          }
        }

        let blob = new Blob([x.data], { type: 'application/pdf' });

        let link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
      });
      // uris.quoteDownloadURI(id);
    },
    downloadOrderLegal(id, invoiceID) {
      if (
        invoiceID ||
        (!invoiceID &&
          confirm(
            '¿Estás seguro que deseas generar una factura para el pedido ' +
              id +
              '?'
          ))
      ) {
        actions.downloadOrderLegal(id).then((x) => {
          let fileName = 'Factura.pdf';

          const contentDisposition = x.headers['content-disposition'];
          if (contentDisposition) {
            const fileNameMatch = contentDisposition.match(/filename=(.+)/);
            if (fileNameMatch.length === 2) {
              fileName = fileNameMatch[1];
            }
          }

          let blob = new Blob([x.data], { type: 'application/pdf' });

          let link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = fileName;
          link.click();

          //this.$refs.table.refresh();
        });
      }
      // uris.quoteDownloadURI(id);
    },
    downloadDelivery(id) {
      actions.downloaDelivery(id).then((x) => {
        let fileName = 'Albaran.pdf';

        const contentDisposition = x.headers['content-disposition'];
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename=(.+)/);
          if (fileNameMatch.length === 2) {
            fileName = fileNameMatch[1];
          }
        }

        let blob = new Blob([x.data], { type: 'application/pdf' });

        let link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
      });
      // uris.quoteDownloadURI(id);
    },
    // removeSelected() {
    //   this.table.selected.map((x) => {
    //     this.removeDelivery(x);
    //   });
    // },
    removeDelivery(id) {
      if (
        confirm(
          '¿Estás seguro que deseas eliminar el albarán número ' + id + '?'
        )
      ) {
        actions.deleteDelivery(id).then((x) => {
          this.$refs.table.refresh();
        });
      }
    },
    toggleCell($event, id) {
      if ($event) {
        this.table.selected.push(id);
      } else {
        this.table.selected = this.table.selected.filter((item) => item !== id);
      }
    },
    toggleAll(checked) {
      this.table.selected = checked
        ? this.$refs.table.data.map((row) => row.reference)
        : [];
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
::v-deep .bg-light-warning {
  background-color: rgba(255, 255, 213, 0.55) !important;
  &:hover {
    color: #212529;
    background-color: rgba(255, 255, 213, 0.95) !important;
  }
}
</style>
